import React, { useEffect, useState, useCallback, forwardRef } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { MDBBtn, MDBCol, MDBDatatable, MDBIcon, MDBInput, MDBListGroup, MDBListGroupItem, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle, MDBPopover, MDBPopoverBody, MDBPopoverHeader, MDBRow, MDBSelect, MDBSpinner, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane } from 'mdb-react-ui-kit';
import { useCart } from '../components/CartContext.js';
import { downloadclassinvoice, getMemberTransactions, membersessions, getClassTransactionbyNumber, getPlans } from '../../services/memberApiServices';
import { formatDateTimeWithTZ } from '../../utils/DateFormat';
import DatePicker from "react-datepicker";
import calImg from "../../components/images/calendar.svg";
import TransactionDetails from "../../components/TransactionDetails";
import BookingSuccess from '../../components/class/BookingSuccess';
import ClassTransactionDetails from '../../components/class/classTransactionDetails';
import { useNavigate } from 'react-router';
import transactionImg from "../../memberportal/assets/images/transaction.gif";
import { BasePlanName } from '../../utils/BasePlanName';


// Constants for payment modes and statuses
const PAYMENT_MODES = {
    '-3': 'Razorpay',
    '1': 'Cash',
    '2': 'Card',
    '3': 'UPI',
    '4': 'Wallet',
    '5': 'Coupon',
    '-2': 'Payment Link',
    '6': 'Multiple',
};

const STATUS_TYPES = {
    PAUSED: 'paused',
    EXTENDED: 'extend',
    INACTIVE: 'Inactive',
    ACTIVE: 'Active',
    REFUND: 'Refund'
};


function MemberTransactions() {
    const { getMemberId, getGymId, getMemberNumber, handleReload } = useCart();
    const [allData, setAllData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [classTrans, setClassTrans] = useState([]);
    const [filteredClassTrans, setFilteredClassTrans] = useState([]);
    const [sessionData, setSessionData] = useState([]);
    const [basicActive, setBasicActive] = useState("tab1");

    // Loading states
    const [isLoadingMembership, setIsLoadingMembership] = useState(true);
    const [isLoadingSessions, setIsLoadingSessions] = useState(true);
    const [isApplyingFilters, setIsApplyingFilters] = useState(false);
    const [viewTrans, setViewTrans] = useState(false)
    const [viewClassTrans, setViewClassTrans] = useState(false)
    const navigate = useNavigate();
    const toogleViewTrans = () => {
        setViewTrans(false)
    }
    const toogleViewClassTrans = () => {
        setViewClassTrans(false)
    }
    const [selectedTrans, setSelectedTrans] = useState({})
    const [tId, setTId] = useState(null);
    const [Rid, setRid] = useState(null);
    const [token, setToken] = useState(null)
    const [transid, settransid] = useState("")
    // Filter states for membership transactions
    const [membershipFilters, setMembershipFilters] = useState({
        orderId: '',
        dateRange: [],
        membershipType: 'all',
        status: 'all'
    });
    const [success, setSuccess] = useState(false)
    // Filter states for class transactions
    const [classFilters, setClassFilters] = useState({
        orderId: '',
        dateRange: [],
        className: 'all',
        status: 'all',
        paymentMode: 'all'
    });

    const [membershipData, setMembershipData] = useState({
        columns: [
            "Order Id", "Plan/Addon", "Date", "Start Date", "End Date",
            "Session(s)", "Balance Session(s)", "Paid Amount", "Due",
            "Total(Incl.tax)", "Payment Mode", "Status", "Invoice"
        ],
        rows: [],
    });

    const [classData, setClassData] = useState({
        columns: [
            "Order Id", "Class", "Date", "Trainer", "Start Date",
            "End Date", "Total(Incl.tax)", "Payment Mode", "Quantity", "Status", "Invoice"
        ],
        rows: [],
    });

    const [plans, setPlans] = useState("");

    const formatDate = useCallback((date) => {
        return formatDateTimeWithTZ(date).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
        });
    }, []);

    const formatCurrency = useCallback((amount) => {
        return amount ? `₹${amount}` : "--";
    }, []);

    const getPaymentMode = useCallback((payment) => {
        if (payment.mode === 6) {
            const payInfo = JSON.parse(payment.payinfo).info;
            return (
                <>

                    <div className='popver-icon-btn'>
                        <label>
                            Multiple Payment
                        </label>

                        <MDBPopover
                            color="primary"
                            btnChildren={<i className="fa-solid fa-circle-info"></i>}
                            dismiss
                            placement="left"
                            className='popover-content'
                        >
                            <MDBPopoverHeader>Over View</MDBPopoverHeader>
                            <MDBPopoverBody>
                                <MDBListGroup light>
                                    <MDBListGroupItem noBorders className='d-flex justify-content-between pay-list'>
                                        <span><i class="fas fa-money-bill me-1"></i> Cash</span>
                                        <span className='fw-bold'>{payInfo.cash_amt ? payInfo.cash_amt : "0"}</span>
                                    </MDBListGroupItem>

                                    <MDBListGroupItem noBorders className='d-flex justify-content-between pay-list'>
                                        <span><i class="fas fa-credit-card me-1"></i> Credit Card</span>
                                        <span className='fw-bold'>{payInfo.cc_amt ? payInfo.cc_amt : "0"}</span>
                                    </MDBListGroupItem>
                                    <MDBListGroupItem noBorders className='d-flex justify-content-between pay-list'>
                                        <span><MDBIcon fas icon="globe-americas me-1" />  UPI</span>
                                        <span className='fw-bold'>{payInfo.upi_amt ? payInfo.upi_amt : "0"} {payInfo.upi_input ? `(${payInfo.upi_input})` : ""}</span>
                                    </MDBListGroupItem>
                                    <MDBListGroupItem noBorders className='d-flex justify-content-between pay-list'>
                                        <span><i class="fas fa-wallet me-1"></i> Wallet</span>
                                        <span className='fw-bold'> {payInfo.wallet_amt ? payInfo.wallet_amt : "0"}  {payInfo.wallet_input ? `(${payInfo.wallet_input})` : ""}</span>
                                    </MDBListGroupItem>
                                </MDBListGroup>

                            </MDBPopoverBody>
                        </MDBPopover>

                    </div>

                </>
            );
        }
        if (payment.mode >= 7) {
            return JSON.parse(payment.payinfo).info.userpaymethod;
        }
        return PAYMENT_MODES[payment.mode] || "Account Payment Type";
    }, []);

    const getClassPaymentMode = useCallback((mode) => {
        return mode === "online" ? "Razorpay" : mode || "--";
    }, []);

    const getStatus = useCallback((data, session, pauseObj, filterExtend) => {
        if (pauseObj?.resume) return STATUS_TYPES.PAUSED;
        if (filterExtend.length > 0) return STATUS_TYPES.EXTENDED;
        if ((session?.length > 0 && session[0].balsessions <= 0) || (new Date(data.expirydate) < new Date())) {
            return STATUS_TYPES.INACTIVE;
        }
        return STATUS_TYPES.ACTIVE;
    }, []);

    // Filter the raw membership data before generating table rows
    const filterMembershipData = useCallback((data, currentFilters) => {
        if (!data.length || !data[0].trans) return [];

        return data[0].trans.filter(transaction => {
            // Filter by Order ID
            if (currentFilters.orderId &&
                !(transaction.token || transaction.tId || '').toString().includes(currentFilters.orderId)) {
                return false;
            }

            // Filter by date range
            if (currentFilters.dateRange.length === 2) {
                const [startDate, endDate] = currentFilters.dateRange;
                const transactionDate = new Date(transaction.createdAt);

                if (startDate && transactionDate < startDate) return false;
                if (endDate && transactionDate > endDate) return false;
            }

            // Filter by membership type
            if (currentFilters.membershipType !== 'all') {
                if (currentFilters.membershipType === 'plan' && transaction.isplan !== "1") return false;
                if (currentFilters.membershipType === 'addon' && transaction.isplan === "1") return false;
            }

            // For status filter, we need to determine the status first
            const pauseObj = (transaction.pause?.length > 0)
                ? transaction.pause.sort((a, b) => b.sno - a.sno)[0]
                : {};

            const filterExtend = transaction.extend?.length > 0
                ? transaction.extend.filter(obj => {
                    const oldEndDate = new Date(obj.oldEndDate);
                    const newEndDate = new Date(obj.newEndDate);
                    const currentDate = new Date();
                    return oldEndDate <= currentDate && currentDate <= newEndDate;
                })
                : [];

            const session = sessionData.filter(item => item.transid === transaction._id);
            const status = getStatus(transaction, session, pauseObj, filterExtend);

            if (currentFilters.status !== 'all' && status !== currentFilters.status) {
                return false;
            }

            return true;
        });
    }, [sessionData, getStatus]);

    // Filter the raw class data before generating table rows
    const filterClassData = useCallback((data, currentFilters) => {
        if (!data.length) return [];

        return data.filter(transaction => {
            // Filter by Order ID
            if (currentFilters.orderId &&
                !(transaction.token || transaction.tId || '').toString().includes(currentFilters.orderId)) {
                return false;
            }

            // Filter by date range
            if (currentFilters.dateRange.length === 2) {
                const [startDate, endDate] = currentFilters.dateRange;
                const transactionDate = new Date(transaction.createdAt);

                if (startDate && transactionDate < startDate) return false;
                if (endDate && transactionDate > endDate) return false;
            }

            // Filter by class name
            if (currentFilters.className !== 'all' &&
                !transaction.class?.name?.toLowerCase().includes(currentFilters.className.toLowerCase())) {
                return false;
            }

            // Filter by payment mode
            if (currentFilters.paymentMode !== 'all' &&
                getClassPaymentMode(transaction.mode) !== currentFilters.paymentMode) {
                return false;
            }

            // Filter by status
            const status = transaction.status === "refund"
                ? STATUS_TYPES.REFUND
                : new Date(transaction.expirydate) < new Date()
                    ? STATUS_TYPES.INACTIVE
                    : STATUS_TYPES.ACTIVE;

            if (currentFilters.status !== 'all' && status !== currentFilters.status) {
                return false;
            }

            return true;
        });
    }, [getClassPaymentMode]);

    // Apply membership filters function - only called when Apply button is clicked
    const applyMembershipFilters = useCallback(() => {
        setIsApplyingFilters(true);
        setTimeout(() => {
            if (allData.length) {
                const filtered = filterMembershipData(allData, membershipFilters);
                setFilteredData(filtered.length ? [{ ...allData[0], trans: filtered }] : []);
            }
            setIsApplyingFilters(false);
        }, 500); // Small delay to show loading state
    }, [allData, membershipFilters, filterMembershipData]);

    // Apply class filters function - only called when Apply button is clicked
    const applyClassFilters = useCallback(() => {
        setIsApplyingFilters(true);
        setTimeout(() => {
            if (classTrans?.length) {
                const filtered = filterClassData(classTrans, classFilters);
                setFilteredClassTrans(filtered);
            }
            setIsApplyingFilters(false);
        }, 500); // Small delay to show loading state
    }, [classTrans, classFilters, filterClassData]);

    // Clear membership filters function
    const clearMembershipFilters = useCallback(() => {
        setIsApplyingFilters(true);
        setTimeout(() => {
            setMembershipFilters({
                orderId: '',
                dateRange: [],
                membershipType: 'all',
                status: 'all'
            });
            setFilteredData(allData);
            setIsApplyingFilters(false);
        }, 500);
    }, [allData]);

    // Clear class filters function
    const clearClassFilters = useCallback(() => {
        setIsApplyingFilters(true);
        setTimeout(() => {
            setClassFilters({
                orderId: '',
                dateRange: [],
                className: 'all',
                status: 'all',
                paymentMode: 'all'
            });
            setFilteredClassTrans(classTrans);
            setIsApplyingFilters(false);
        }, 500);
    }, [classTrans]);


    const [refresh, setRefresh] = useState(false)
    console.log(getMemberId(), 'getMemberId()');

    const filterLastThreeMonthsOrLatest = (data) => {
        if (!data.length || !data[0].trans) return data;

        const now = new Date();
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(now.getMonth() - 3);

        const recentTransactions = data[0].trans.filter(transaction => {
            const transactionDate = new Date(transaction.createdAt);
            return transactionDate >= threeMonthsAgo;
        });

        if (recentTransactions.length > 0) {
            return [{ ...data[0], trans: recentTransactions }];
        }

        if (data[0].trans.length > 0) {
            const sortedTransactions = [...data[0].trans].sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt);
            });
            const lastThreeTransactions = sortedTransactions.slice(0, 3);
            return [{ ...data[0], trans: lastThreeTransactions }];
        }
        return [];
    };

    useEffect(() => {
        const fetchMembershipData = async () => {
            try {
                if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                    navigate('/memberlogin', { state: { path: "/membertransaction" } })
                    return
                }
                setIsLoadingMembership(true);
                const [transResponse, sessionsResponse] = await Promise.all([
                    getMemberTransactions(getMemberId()),
                    membersessions(getMemberId())
                ]);

                if (transResponse && transResponse !== "false") {
                    const data = await transResponse.json();
                    console.log(data, 'datadatadata')
                    const filteredData = filterLastThreeMonthsOrLatest(data);
                    console.log(filteredData, 'filteredData');

                    setAllData(filteredData);


                    setFilteredData(filteredData);
                }

                if (sessionsResponse && sessionsResponse !== "false") {
                    setSessionData(await sessionsResponse.json());
                }
            } catch (error) {
                console.error("Error fetching membership data:", error);
            } finally {
                setIsLoadingMembership(false);
            }
            setRefresh(false)
        };
        if (getMemberId()) {
            fetchMembershipData();
        } else {
            setIsLoadingMembership(false);
        }

    }, [getMemberId, refresh]);

    const handleTransClik = (trans) => {
        setViewTrans(true)
        setSelectedTrans(trans)
    }

    const handleTransDownload = (type, transid) => {
        setTId(transid)
        downloadInvoice(type, transid)
    }


    useEffect(() => {
        async function fetchPlans() {
            try {
                const loggedUser = JSON.parse(localStorage.getItem("memberinfo"));
                const planResponse = await getPlans(loggedUser.gymid);

                if (!planResponse || planResponse === "false") {
                } else {
                    const plans = await planResponse.json();
                    if (plans) {
                        setPlans(plans);
                    }
                }
            } catch (error) {
                console.error("Error fetching plans:", error);
            }
        }

        fetchPlans();

    }, [getMemberId, refresh, basicActive, filteredData, sessionData, classTrans, allData, membershipFilters, filterMembershipData]);




    // Transform filtered membership data to table format
    useEffect(() => {
        if (!filteredData.length) {
            setMembershipData(prev => ({ ...prev, rows: [] }));
            return;
        }

        const sortedTrans = [...filteredData[0].trans].sort(
            (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
        );

        const rows = sortedTrans.map(data => {
            const pauseObj = (data.pause?.length > 0)
                ? data.pause.sort((a, b) => b.sno - a.sno)[0]
                : {};

            const filterExtend = data.extend?.length > 0
                ? data.extend.filter(obj => {
                    const oldEndDate = new Date(obj.oldEndDate);
                    const newEndDate = new Date(obj.newEndDate);
                    const currentDate = new Date();
                    return oldEndDate <= currentDate && currentDate <= newEndDate;
                })
                : [];

            const session = sessionData.length > 0 ? sessionData.filter(item => item.transid === data._id) : {};
            const planData = filteredData.length > 0 ? filteredData[0]?.plan.find(item => item._id === data.itemid) : {};

            const addData = filteredData.length > 0 ? filteredData[0]?.addons.find(item => item._id === data.itemid) : {};
            const subplanData = filteredData[0]?.subplan.find(item => item._id === data.itemid);

            let itemName = "";


            if (subplanData) {

                const baseName = BasePlanName(plans, subplanData.baseplan);
                // itemName = `${baseName} - ${subplanData.name}`;
                itemName = baseName ? `${baseName} - ${subplanData.name}` : subplanData.name;

            } else {
                itemName = planData?.name || addData?.name || "Unknown";
            }

            return [
                <div className="link-color" onClick={(e) => togglePopup(e, "membership", data.tId, data._id, data.token, data.parentname)}>{data.token || data.tId}</div>,
                itemName,
                formatDate(data.createdAt),
                formatDate(data.startdate),
                formatDate(data.expirydate),
                session.length ? session[0].totalsessions : "--",
                session.length ? session[0].balsessions : "--",
                formatCurrency(data.payment.paid),
                data.payment.balance && data.payment.balance !== 0
                    ? formatCurrency(data.payment.balance)
                    : "--",
                formatCurrency(data.payment.totalamount),
                getPaymentMode(data.payment),
                <div className="title">
                    {getStatus(data, session, pauseObj, filterExtend)}
                </div>,
                <div className="link-color" onClick={() => handleTransDownload("membership",
                    data.tId)}
                ><i class="fa-solid fa-download"></i>
                    Invoice
                </div>
            ];
        }).filter(Boolean);

        setMembershipData(prev => ({ ...prev, rows }));
    }, [filteredData, sessionData, formatDate, formatCurrency, getPaymentMode, getStatus]);

    console.log(getGymId(), getMemberNumber());
    const filterLastThreeMonthsOrLatestClass = (data) => {
        if (!data.length) return data;

        const now = new Date();
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(now.getMonth() - 3);


        const recentTransactions = data.filter(transaction => {
            const transactionDate = new Date(transaction.createdAt);
            return transactionDate >= threeMonthsAgo;
        });


        if (recentTransactions.length > 0) {
            return recentTransactions;
        }


        if (data.length > 0) {
            const sortedTransactions = [...data].sort((a, b) => {
                return new Date(b.createdAt) - new Date(a.createdAt);
            });

            return sortedTransactions.slice(0, 3);
        }

        return [];
    };

    useEffect(() => {
        const fetchClassTransactions = async () => {
            try {
                if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                    navigate('/memberlogin', { state: { path: window.location.pathname } })
                    return
                }
                setIsLoadingSessions(true);
                const response = await getClassTransactionbyNumber(
                    getGymId(),
                    { number: getMemberNumber() }
                );

                if (response && response !== "false") {
                    const data = await response.json();
                    console.log(data, 'data');

                    const successTransactions = data?.length > 0 ? data.filter(item => item.status === "success") : [];

                    console.log(successTransactions, "success only");
                    const filteredData = filterLastThreeMonthsOrLatestClass(successTransactions);
                    setClassTrans(successTransactions);
                    setFilteredClassTrans(filteredData);
                    // setClassTrans(data);
                    // setFilteredClassTrans(data);
                }
            } catch (error) {
                console.error("Error fetching class transactions:", error);
            } finally {
                setIsLoadingSessions(false);
            }
        };
        if (getGymId() && getMemberNumber()) {
            fetchClassTransactions();
        } else {
            setIsLoadingSessions(false);
        }

    }, [getGymId, getMemberNumber]);

    // Transform filtered class data to table format
    useEffect(() => {
        if (!filteredClassTrans.length) {
            setClassData(prev => ({ ...prev, rows: [] }));
            return;
        }

        const rows = filteredClassTrans.map(data => [
            <button className="button-link link-color" onClick={(event) => togglePopup(event, "class", data.tid, data._id)}>{data.token ? data.token : data.tId}</button>,
            data?.class?.name || "Unknown class",
            formatDate(data.createdAt),
            data?.staff?.firstname
                ? `${data?.staff?.firstname} ${data?.staff?.lastname}`
                : "N/A",
            formatDate(data.startdate),
            formatDate(data.expirydate),
            formatCurrency(data.totalamount),
            getClassPaymentMode(data.mode),
            data.quantity || "--",
            data.status === "refund"
                ? STATUS_TYPES.REFUND
                : new Date(data.expirydate) < new Date()
                    ? STATUS_TYPES.INACTIVE
                    : STATUS_TYPES.ACTIVE,
            <div className="link-color" onClick={() => handleTransDownload("class",
                data.tid)}
            ><i class="fa-solid fa-download"></i>
                Invoice
            </div>
        ]);

        setClassData(prev => ({ ...prev, rows }));
    }, [filteredClassTrans, formatDate, plans, formatCurrency, getClassPaymentMode]);

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };

    const handleMembershipFilterChange = (e) => {
        const { name, value } = e.target;
        setMembershipFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleClassFilterChange = (e) => {
        const { name, value } = e.target;
        setClassFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleMembershipDateRangeChange = (dates) => {
        setMembershipFilters(prev => ({
            ...prev,
            dateRange: dates
        }));
    };

    const handleClassDateRangeChange = (dates) => {
        setClassFilters(prev => ({
            ...prev,
            dateRange: dates
        }));
    };

    const CalenderInput = forwardRef(({ value, onClick }, ref) => (
        <>
            <span className="form-control select-input placeholder-active me-3 shadow-1 d-flex align-items-center justify-content-between" onClick={onClick}>
                <p className="d-inline m-0 me-2">
                    {value === "" ? "Custom Range" : value}
                </p>
                <img src={calImg} alt="Custom Range" ref={ref} title="Select Custom Range" />
            </span>
        </>
    ));

    // Get unique class names for filter dropdown
    const uniqueClassNames = Array.isArray(classTrans)
        ? [...new Set(classTrans.map(item => item.class?.name))].filter(Boolean)
        : [];
    console.log(allData, "allData");
    console.log(tId, transid);

    const togglePopup = (event, from, tId, _id, token, id) => {
        event.preventDefault();
        setTId(tId);
        settransid(_id)
        setToken(token)
        // setIsOpen(!isOpen);
        if (from == "membership") {
            setViewTrans(true)
        } else {
            setViewClassTrans(true)
        }


        setRid(id);

    };
    const toggleClassPopup = () => {

    }

    const closePopup = () => {
        // if (isOpen) {
        //     setIsOpen(false);
        // }
        setViewTrans(false)
        setViewClassTrans(false)
    };


    const downloadInvoice = async (path, tranid
    ) => {
        try {
            if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                navigate('/memberlogin', { state: { path: "/membertransaction" } })
                return
            }
            const update = {
                tid: tranid ? tranid : tId,
                bid: getGymId(),
                type: path
            }
            console.log(update, 'update');

            const response = await downloadclassinvoice(update, "user")

            const data = await response.json();
            console.log(data, "data");

            if (data.url) {
                const link = document.createElement("a");
                link.href = data.url;
                link.setAttribute("download", "filename.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Error fetching signed URL", error);
        }
    }
    const homeCallback = () => {
        setSuccess(false)

        // setViewTrans(false)
        setRefresh(true)
        // navigate("/membershipplans")
    }

    const handleSuccessCallback = () => {
        setSuccess(true)
        setViewTrans(false)
    }

    const handleRefresh = () => {
        setRefresh(true)
        handleReload()
    }
    return (
        <>
            {!success && <div className="dashboard-container">
                <Sidebar active={"4"} handleRefresh={handleRefresh} />
                <div className="main-content">
                    <Header title={"Transaction"} />

                    <div className="dashboard-content">
                        <MDBTabs className='overflow-hidden'>
                            <MDBTabsItem className='tab_item'>
                                <MDBTabsLink
                                    onClick={() => handleBasicClick("tab1")}
                                    active={basicActive === "tab1"}
                                >
                                    <span> <i class="fas fa-coins me-2"></i>  Membership Transactions</span>
                                </MDBTabsLink>
                            </MDBTabsItem>
                            <MDBTabsItem className='tab_item'>
                                <MDBTabsLink
                                    onClick={() => handleBasicClick("tab2")}
                                    active={basicActive === "tab2"}
                                >
                                    <span> <i class="fas fa-coins me-2"></i> Booking History</span>
                                </MDBTabsLink>
                            </MDBTabsItem>
                        </MDBTabs>

                        <MDBTabsContent>
                            <MDBTabsPane open={basicActive === "tab1"} show={basicActive === "tab1"}>
                                <div className="filters-container rounded-0 h-100">
                                    <div className="filter-row">
                                        <div className="filter-group">
                                            <label className="filter-label">OrderId</label>
                                            <input
                                                className='form-control meamber_input'
                                                placeholder='Search by OrderId'
                                                name="orderId"
                                                value={membershipFilters.orderId}
                                                onChange={handleMembershipFilterChange}
                                            />
                                        </div>
                                        <div className="filter-group">
                                            <label className="filter-label">Date Range</label>
                                            <DatePicker
                                                className="form-control meamber_input"
                                                dateFormat={"d/M/yyyy"}
                                                selectsRange={true}
                                                startDate={membershipFilters.dateRange[0]}
                                                endDate={membershipFilters.dateRange[1]}
                                                onChange={handleMembershipDateRangeChange}
                                                isClearable={false}
                                                customInput={<CalenderInput />}
                                            />
                                        </div>

                                        <div className="filter-group">
                                            <label className="filter-label">Membership Type</label>
                                            <select
                                                className="member-filter-select form-select"
                                                name="membershipType"
                                                value={membershipFilters.membershipType}
                                                onChange={handleMembershipFilterChange}
                                            >
                                                <option value="all">All Types</option>
                                                <option value="plan">Plans</option>
                                                <option value="addon">Addons</option>
                                            </select>
                                        </div>

                                        <div className="filter-group">
                                            <label className="filter-label">Status</label>
                                            <select
                                                className="member-filter-select form-select"
                                                name="status"
                                                value={membershipFilters.status}
                                                onChange={handleMembershipFilterChange}
                                            >
                                                <option value="all">All</option>
                                                <option value="Active">Active</option>
                                                <option value="Inactive">Inactive</option>
                                                <option value="paused">Paused</option>
                                                <option value="extend">Extend</option>
                                                <option value="Refund">Refund</option>
                                            </select>
                                        </div>

                                        <div className="filter-buttons">
                                            <button
                                                className="filter-btn apply-btn"
                                                onClick={applyMembershipFilters}
                                                disabled={isApplyingFilters}
                                            >
                                                {/* {isApplyingFilters ? (
                                                <MDBSpinner size='sm' role='status' />
                                            ) : 'Apply'} */}
                                                Apply
                                            </button>
                                            <button
                                                className="filter-btn cancel-btn"
                                                onClick={clearMembershipFilters}
                                                disabled={isApplyingFilters}
                                            >
                                                {/* {isApplyingFilters ? (
                                                <MDBSpinner size='sm' role='status' />
                                            ) : 'Clear'} */}
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                    {isLoadingMembership ? (
                                        <div className="transaction-loading">
                                            <img src={transactionImg} alt="" />
                                            <h4>Loading membership transactions...</h4>
                                        </div>
                                    ) : (
                                        <div className='member-table'>
                                            <MDBDatatable
                                                className="member-transactiontable mt-3"
                                                fixedHeader
                                                entries={25}
                                                data={membershipData}
                                            />
                                        </div>
                                    )}
                                </div>

                            </MDBTabsPane>
                            <MDBTabsPane open={basicActive === "tab2"} show={basicActive === "tab2"}>
                                <div className="filters-container h-100">
                                    <div className="filter-row">
                                        <div className="filter-group">
                                            <label className="filter-label">OrderId</label>
                                            <input
                                                className='form-control .meamber_input'
                                                placeholder='Search by OrderId'
                                                name="orderId"
                                                value={classFilters.orderId}
                                                onChange={handleClassFilterChange}
                                            />
                                        </div>
                                        <div className="filter-group">
                                            <label className="filter-label">Date Range</label>
                                            <DatePicker
                                                className='form-control .meamber_input'
                                                dateFormat={"d/M/yyyy"}
                                                selectsRange={true}
                                                startDate={classFilters.dateRange[0]}
                                                endDate={classFilters.dateRange[1]}
                                                onChange={handleClassDateRangeChange}
                                                isClearable={false}
                                                customInput={<CalenderInput />}
                                            />
                                        </div>

                                        <div className="filter-group">
                                            <label className="filter-label">Class Name</label>
                                            <select
                                                className="member-filter-select "
                                                name="className"
                                                value={classFilters.className}
                                                onChange={handleClassFilterChange}
                                            >
                                                <option value="all">All Classes</option>
                                                {uniqueClassNames.map((className, index) => (
                                                    <option key={index} value={className}>{className}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="filter-group">
                                            <label className="filter-label">Payment Mode</label>
                                            <select
                                                className="member-filter-select"
                                                name="paymentMode"
                                                value={classFilters.paymentMode}
                                                onChange={handleClassFilterChange}
                                            >
                                                <option value="all">All</option>
                                                <option value="Razorpay">Razorpay</option>
                                                <option value="offline">offline</option>
                                            </select>
                                        </div>

                                        <div className="filter-group">
                                            <label className="filter-label">Status</label>
                                            <select
                                                className="member-filter-select"
                                                name="status"
                                                value={classFilters.status}
                                                onChange={handleClassFilterChange}
                                            >
                                                <option value="all">All</option>
                                                <option value="Active">Active</option>
                                                <option value="Inactive">Inactive</option>
                                                <option value="Refund">Refund</option>
                                            </select>
                                        </div>

                                        <div className="filter-buttons">
                                            <button
                                                className="filter-btn apply-btn"
                                                onClick={applyClassFilters}
                                                disabled={isApplyingFilters}
                                            >
                                                {/* {isApplyingFilters ? (
                                                <MDBSpinner size='sm' role='status' />
                                            ) : 'Apply'} */}
                                                Apply
                                            </button>
                                            <button
                                                className="filter-btn cancel-btn"
                                                onClick={clearClassFilters}
                                                disabled={isApplyingFilters}
                                            >
                                                {/* {isApplyingFilters ? (
                                                <MDBSpinner size='sm' role='status' />
                                            ) : 'Clear'} */}
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                    {isLoadingSessions ? (
                                        <div className="transaction-loading">
                                            <img src={transactionImg} alt="" />
                                            <h4>Loading session transactions...</h4>
                                        </div>
                                    ) : (
                                        <div className='member-table'>
                                            <MDBDatatable
                                                className="member-transactiontable mt-3"
                                                fixedHeader
                                                entries={25}
                                                data={classData}
                                            />
                                        </div>
                                    )}
                                </div>

                            </MDBTabsPane>
                        </MDBTabsContent>
                    </div>
                </div>
            </div>}


            <MDBModal tabIndex='-1' open={viewTrans} onClose={() => setViewTrans(false)}>
                <MDBModalDialog centered size='md'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Transaction Details</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toogleViewTrans}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <div>

                                <TransactionDetails
                                    oncancel={closePopup}
                                    // onAssociate={openAUserPop}
                                    id={tId}
                                    gymid={getGymId()}
                                    token={token}
                                    Rtoken={Rid}
                                    transid={transid}
                                    from="member"
                                    SuccessCallback={handleSuccessCallback}
                                    downloadInvoice={downloadInvoice}
                                // filters={filteredobject}
                                />
                            </div>
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            <MDBModal tabIndex='-1' open={viewClassTrans} onClose={() => setViewClassTrans(false)}>
                <MDBModalDialog centered size='md'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Transaction Details</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toogleViewClassTrans}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <div>
                                <ClassTransactionDetails
                                    oncancel={closePopup}
                                    id={tId}
                                    gymid={getGymId()}
                                    transid={transid}
                                    from="member"
                                    downloadInvoice={downloadInvoice}
                                />
                            </div>
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            {success && <BookingSuccess homeCallback={homeCallback} trans={{}} downloadInvoice={downloadInvoice} content={"Your Payment was successfully completed"} />}
        </>

    );
}

export default MemberTransactions;